export default "__VITE_ASSET__UmLAx6yI__"